import { Select } from "antd";
import styled from "styled-components";

export const ListHospitalWrapper = styled.div`
  margin-top: 20px;
  margin-left: 20px;
`;
export const TitleListHospital = styled.div`
  font-weight: 500;
  font-size: 20px;
  margin: 8px 0px;
`;
export const SelectHospitals = styled(Select)`
  width: 217px;
`;
export const SelectWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 14px;
`;
export const IconAdd = styled.img`
  margin-left: 20px;
  width: 24px;
  height: auto;
  cursor: pointer;
`;
